import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCurrencyLira: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="currency-lira, money"><path d="M8.75 3V20.25H12C15.4518 20.25 18.25 17.4518 18.25 14" stroke="currentColor" strokeWidth="1.5"/><path d="M4.5 11.5L16 7" stroke="currentColor" strokeWidth="1.5"/><path d="M4.5 15.5L16 11" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconCurrencyLira;
